import { Constante } from '../../constante';

export class AuthUtility {
    static initSessionData(token: string): void {
        sessionStorage.setItem(Constante.TOKEN_APP, token);
    }

    static closeSessionData(): void {
        sessionStorage.removeItem(Constante.TOKEN_APP);
        sessionStorage.removeItem(Constante.INFO_USER);
        sessionStorage.clear();
    }

    static getToken(): string | null {
        const token = sessionStorage.getItem(Constante.TOKEN_APP);
        if (token && token.length > 0) {
            return token;
        }
        return null;
    }

    static isAuthenticated(): boolean {
        const token = AuthUtility.getToken();
        return !!(token && token.length > 0);
    }

    static setValueUser(user: unknown): void {
        sessionStorage.setItem(Constante.INFO_USER, JSON.stringify(user));
    }

    static getValueUser<T = unknown>(): T | null {
        const user = sessionStorage.getItem(Constante.INFO_USER);
        if (user && user.length > 0) {
            return JSON.parse(user) as T;
        }
        return null;
    }
}
